// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_S8u","cls2":"Base-cls2_Ian Base-cls1_S8u","variant-default":"Base-variant-default__2F","hoisted":"Base-hoisted_Jqu","variant-dense":"Base-variant-dense_zCJ"};